import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import Footer from "./components/Footer/Footer";
import Error from "./pages/Error/Error.jsx";
import About from "./pages/About/About";
import PageContact from "./pages/PageContact/PageContact";
import Stranger from "./pages/Stranger/Stranger";
import Connection from "./pages/Connection/Connection";
import Dashboard from "./pages/Dashboard/Dashboard";
import { RequireAuth } from "react-auth-kit";
import Article from "./pages/Article/Article";
import OneArticle from "./pages/OneArticle/OneArticle";
import { AuthProvider } from "./components/AuthProvider";
import ResetPasswordPage from "./pages/ResetPasswordPage/ResetPasswordPage.jsx";
import Privacy from "./pages/Privacy/Privacy.jsx";
import Legal from "./pages/Legal/Legal.jsx";
import Cookie from "./components/Cookie/Cookie.jsx";
import { useCookies } from "react-cookie";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div key={location.key} className="page-transition">
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="*" element={<Error />} />
        <Route path="apropos" element={<About />} />
        <Route path="contact" element={<PageContact />} />
        <Route path="étranger" element={<Stranger />} />
        <Route path="connexion" element={<Connection />} />
        <Route path="article/:id" element={<OneArticle />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="confidentialité" element={<Privacy />} />
        <Route path="légal" element={<Legal />} />
        <Route
          path="article"
          element={
            <RequireAuth loginPath="/connexion">
              <Article />
            </RequireAuth>
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  const [cookies] = useCookies(["cookieConsent"]);

  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <AnimatedRoutes />
      </AuthProvider>
      {!cookies.cookieConsent && <Cookie />}
      <Footer />
    </BrowserRouter>
  );
}

export default App;
